<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="where.modelid"
          :to="{ path: '/car-price-log' }"
          >价格日志管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>车系价格详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex">
        <el-col :span="7" style="margin-bottom:10px">
          <el-date-picker
            v-model="timeArr"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            :default-time="['12:00:00']"
            size="mini"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini"
            >查询</el-button>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <div id="myChart" style="height: 300px; width: 100%"></div>
      </el-row>
      <el-row style="margin-top: 15px">
        <el-table
          v-loading="loading"
          border
          :data="tableData"
          style="margin-bottom: 10px"
          height="250"
        >
          <el-table-column type="index" fixed label="序号" align="center">
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="车系名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_model.model_name"
            label="车型名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="model_price_true"
            align="center"
            label="出口价"
          >
          </el-table-column>
          <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column prop="address" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-price-log.store')"
                @click="editMessage(scope.row)"
                type="primary"
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-price-log.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[5, 10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 编辑 -->
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm
        @emitplog="onemitplog"
        :row="updataList"
        :edit="isupdata"
      ></myForm>
    </el-dialog>
  </div>
</template>

<script>
import {
  car_price_log,
  addcar_price_log,
  modifycar_price_log,
  delcar_price_log,
} from "../../api/api";
import myForm from "./form";
import echarts from "echarts";
export default {
  name: "car-price-log-show",
  props: {
    modelid: Number,
  },
  components: {
    myForm,
  },
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        modelid: "",
        page: 1,
        pagesize: 10,
      },
      timeArr: [],
      total: 0,
      chartData: {
        columns: ["日期", "价格"],
        rows: [
          { 日期: "2020-05-22", 价格: 1393 },
          { 日期: "2020-05-23", 价格: 3530 },
          { 日期: "2020-05-24", 价格: 2923 },
          { 日期: "2020-05-25", 价格: 1723 },
          { 日期: "2020-05-26", 价格: 3792 },
          { 日期: "2020-05-27", 价格: 4593 },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dialogVisible: false,
      isupdata: false,
      isupdataid: 0,
      updataList: "",
    };
  },
  mounted() {
    if (this.$route.query.modelid)
      this.where.modelid = this.$route.query.modelid;
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      car_price_log(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.total = data.total;
        this.tableData = data.data;
        //曲线数据
        let date = [];
        let price = [];
        for (const itme of this.tableData) {
          date.push(itme.updated_at);
          price.push(itme.model_price_true)
        }
        this.isQuxian(date,price);

        // this.chartData.rows = priceLogArr;
        this.loading = false;
      });
    },
    onemitplog(obj) {
      if (obj.form) {
        if (this.isupdata == true) {
          modifycar_price_log(this.isupdataid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      }
      this.updataList = "";
      this.isupdataid = 0;
      this.isupdata = false;
      this.getList();
      this.dialogVisible = false;
    },
    editMessage(scope) {
      this.updataList = scope;
      this.isupdataid = scope.id;
      this.isupdata = true;
      this.dialogVisible = true;
    },
    delMessage(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcar_price_log(row.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      this.where.start_time =
        this.timeArr == null ? "" : this.dateConversion(this.timeArr[0]);
      this.where.end_time =
        this.timeArr == null ? "" : this.dateConversion(this.timeArr[1]);
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 曲线
    isQuxian(date,price) {
      let myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      let option = {
        title: {
          text: "车系价格统计",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["价格"],
        },
        grid: {
          left: "4%",
          right: "5%",
          bottom: "4%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "价格",
            type: "line",
            stack: "总量",
            data: price,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]") return "";
      let res = JSON.parse(value);
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += i + 1 + ":" + res_json[i] + "\r\n";
      }
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: 30px;
}
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>
